// removed by extract-text-webpack-plugin
module.exports = {"body":"_2Y337xqTSVVvR39KD8MH-b_1","block":"_3Ihk8HElNEgovuzuzYj9lb_1","note":"_3h6Wt1q89Qgx9XW-o8e1zk_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33068da7","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/PixelTest/index.vue
// module id = 2sGt
// module chunks = 1